export const tutorialFlowsCompany = {
  companyPage: [
    {
      element: '[data-tutorial="page-company-organization"]',
      popover: {
        description: `<p>กดปุ่ม “บริษัทและโครงสร้างองค์กร”</p>
          <p>เพื่อจัดการโครงสร้างภายในทีม</p>
          `,
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToNextStepHandlers,
    },
  ],
  companyOrganization: [
    {
      element: '[data-tutorial="company-table"]',
      popover: {
        description: "ภาพรวมทีมที่ต้องการกำหนดโครงสร้างภายในทีม",
        side: "top",
        align: "center",
        nextBtnText: "ต่อไป",
        showButtons: ["next"],
      },
      disableActiveInteraction: true,
    },
    {
      element: '[data-tutorial="company-structure"]',
      popover: {
        description: `<p>กดปุ่ม “โครงสร้างภายในทีม”</p>
           <p>เพื่อสร้างข้อมูลโครงสร้างภายในทีม</p>
          `,
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToNextStepHandlers,
    },
  ],
  teamStructure: [
    {
      element: '[data-tutorial="team-structure"]',
      popover: {
        description: `
        <p>ระบบสร้างโครงสร้างในเบื้องต้น</p>
        <p>โดยการสร้างทีมย่อยในระดับที่ 1 ขึ้นมา 2 ทีม ให้คุณได้เริ่มต้นทดลองใช้งาน</p>
        <p>(สามารถแก้ไข เพิ่มเติมในภายหลังได้)</p>
        `,
        side: "top",
        align: "center",
        nextBtnText: "ต่อไป",
        showButtons: ["next"],
      },
      disableActiveInteraction: true,
    },
    {
      element: '[data-tutorial="team-structure-name"]',
      popover: {
        description: `<div class="flex flex-col gap-2">
              <p>ระบุชื่อของระดับที่ 1 ตามลักษณะโครงสร้างองค์กรของคุณ</p>
              <div>
              <u>ตัวอย่างเช่น</u> <b>ประเทศ, ภาค, จังหวัด, เขต, สาขา, Key Account</b> เป็นต้น
              </div>
              <b>โดยชื่อนี้จะปรากฎตอนคุณเลือกดูรายงาน และสามารถแก้ไขได้ภายหลัง</b>`,
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToNextStepHandlers,
    },
  ],
  configLevelName: [
    {
      element: '[data-tutorial="team-structure-change-name"]',
      popover: {
        description: `<p>ระบุชื่อ <b>“ภาค”</b></p>
          <p>ชื่อนี้จะปรากฎตอนคุณเลือกดูรายงาน กรุณาระบุชื่อในเบื้องต้นก่อนกดปุ่ม “ต่อไป” โดยสามารถแก้ไขได้ภายหลังได้</p>
          `,
        side: "top",
        align: "center",
        nextBtnText: "ต่อไป",
        showButtons: ["next"],
      },
      disableActiveInteraction: true,
    },
    {
      element: '[data-tutorial="team-structure-group-button"]',
      popover: {
        description: `<p>ปุ่มจัดการภายในทีมย่อย สำหรับ</p>
          <ul class="list-disc pl-5">
            <li>เพิ่มหรือลด “ผู้ใช้งาน” ในทีมย่อยนี้</li>
            <li>ลบทีมย่อยนี้</li>
            <li>เปิด/ปิดการใช้งานทีมย่อยนี้</li>
          </ul>
          <b>โดยสามารถจัดการได้ภายหลัง</b>
          `,
        side: "top",
        align: "center",
        nextBtnText: "ต่อไป",
        showButtons: ["next"],
      },
      disableActiveInteraction: true,
    },
    {
      element: '[data-tutorial="team-structure-add-level-two"]',
      popover: {
        description: `<p>กดเพิ่มทีมย่อยสำหรับ <b>“เหนือ”</b></p>
          <p>(หากองค์กรของคุณใช้งานเพียงระดับที่ 1 สามารถแก้ไขได้ในภายหลัง)</p>
          `,
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToNextStepHandlers,
    },
  ],
  configLevelNameTwo: [
    {
      element: '[data-tutorial="team-structure-level-two-name"]',
      popover: {
        description: `<div class="flex flex-col gap-2">
              <p>ระบุชื่อของระดับที่ 2 ตามลักษณะโครงสร้างองค์กรของคุณ</p>
              <div>
              <u>ตัวอย่างเช่น</u> <b>ประเทศ, ภาค, จังหวัด, เขต, สาขา, Key Account</b> เป็นต้น
              </div>
              <b>โดยชื่อนี้จะปรากฎตอนคุณเลือกดูรายงาน และสามารถแก้ไขได้ภายหลัง</b>`,
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToNextStepHandlers,
    },
  ],
  configLevelNameLevelTwo: [
    {
      element: '[data-tutorial="team-structure-change-name-two"]',
      popover: {
        description: `<p>ระบุชื่อ <b>“เขต”</b></p>
          <p>ชื่อนี้จะปรากฎตอนคุณเลือกดูรายงาน กรุณาระบุชื่อในเบื้องต้นก่อนกดปุ่ม “ต่อไป” โดยสามารถแก้ไขได้ภายหลังได้</p>
          `,
        side: "top",
        align: "center",
        nextBtnText: "ต่อไป",
        showButtons: ["next"],
      },
      disableActiveInteraction: true,
    },
    {
      element: '[data-tutorial="team-structure-button-add-same-level"]',
      popover: {
        description: "กดเพื่อเพิ่ม “เขต”",
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToNextStepHandlers,
    },
    {
      element: '[data-tutorial="team-structure-button-change-level"]',
      popover: {
        description: "กดเพื่อเปลี่ยนระดับบังคับบัญชา : ระดับ “ภาค”",
        side: "top",
        align: "center",
        showButtons: [],
      },

    },
    {
      element: "[data-tutorial='team-structure-select-change-level']",
      popover: {
        popoverClass: "driverjs-hidden-popover",
        showButtons: [],
      },
    },
  ],
  configLevelSave: [
    {
      element: '[data-tutorial="team-structure-save-button"]',
      popover: {
        description: `<p>กดบันทึกเพื่อดำเนินการ “บทช่วยสอน” ต่อไป</p>
          <b>โดยสามารถแก้ไขเพิ่มเติมได้ในภายหลัง</b>
          `,
        side: "top",
        align: "center",
        showButtons: [],
      },
      ...clickToCloseStepHandlers,
    },
  ],
} satisfies Record<string, any[]>;